define('TescoMobile_ClubCard/js/view/action-bar-clubcard-price',['uiComponent'], function (Component) {
  'use strict';

  return Component.extend({
    defaults: {
      imports: {
        clubCardPrice: "tm-clubcard-price-provider:clubCardPrice"
      }
    },
    initObservable: function () {
      this._super().observe(['clubCardPrice']);
      return this;
    }
  });
});

